import { ActionIcon, InputBase, type InputBaseProps } from "@mantine/core";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { forwardRef, useState } from "react";
import { IMaskInput } from "react-imask";

/**
 * MaskedTextInput component props
 */
export interface MaskedTextInputProps
  extends
    InputBaseProps,
    Omit<
      React.ComponentPropsWithoutRef<typeof IMaskInput>,
      keyof InputBaseProps
    > {}

export const MaskedTextInput = forwardRef<
  HTMLInputElement,
  MaskedTextInputProps
>(({ mask, ...inputProps }, ref) => (
  <InputBase
    {...inputProps}
    ref={ref}
    component={IMaskInput}
    mask={mask}
    type="text"
  />
));

export const MaskedPasswordInput = forwardRef<
  HTMLInputElement,
  MaskedTextInputProps
>(({ mask, ...passwordInputProps }, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="relative">
      <InputBase
        {...passwordInputProps}
        ref={ref}
        component={IMaskInput}
        mask={mask}
        type={showPassword ? "text" : "password"}
        className="pr-10"
        rightSection={
          <ActionIcon
            variant="transparent"
            color="#354052"
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-2 top-1/2 transform -translate-y-1/2"
          >
            {showPassword ? <IconEyeOff size={22} /> : <IconEye size={22} />}
          </ActionIcon>
        }
      />
    </div>
  );
});
